import 'react';
import webFontLoader from './webFontLoader.js';
import palette from './palette.js';
import layout from './layout.js';
import global from './global.js';
import fontWeights from './fontWeights.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import ActionButtons from './ActionButtons.js';
import Alert from './Alert.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import Button from './Button.js';
import Callout from './Callout.js';
import Card from './Card.js';
import Checkbox from './Checkbox.js';
import Container from './Container.js';
import Dialog from './Dialog.js';
import FieldSet from './FieldSet.js';
import FieldWrapper from './FieldWrapper.js';
import Group from './Group.js';
import Heading from './Heading.js';
import Input from './Input.js';
import Label from './Label.js';
import Page from './Page.js';
import Popover from './Popover.js';
import Select from './Select.js';
import SelectMenu from './SelectMenu.js';
import Tabs from './Tabs.js';
import Table from './Table.js';
import Tag from './Tag.js';
import Textarea from './Textarea.js';
import Toast from './Toast.js'; // @ts-ignore

var _docs = {
  logoPath: 'logo.svg'
};
var medipass = {
  _docs: _docs,
  // Foundation
  global: global,
  webFontLoader: webFontLoader,
  layout: layout,
  fontWeights: fontWeights,
  palette: palette,
  // Components
  ActionButtons: ActionButtons,
  Alert: Alert,
  Button: Button,
  Callout: Callout,
  Card: Card,
  Checkbox: Checkbox,
  Container: Container,
  Dialog: Dialog,
  FieldSet: FieldSet,
  FieldWrapper: FieldWrapper,
  Group: Group,
  Heading: Heading,
  Input: Input,
  Label: Label,
  Page: Page,
  Popover: Popover,
  Select: Select,
  SelectMenu: SelectMenu,
  Tabs: Tabs,
  Table: Table,
  Tag: Tag,
  Textarea: Textarea,
  Toast: Toast
};
export default medipass;